<template>
  <div class="flight-menu-wrapper">
    <div class="pb-4">
      <div class="w-full grid grid-cols-2 text-center pb-16">
        <div class="flight-direction-menu-item" @click="setFlightDirection('departures')" :class="{ active: flightDirection == 'departures'}">
          <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.1184 3.48869L7.55122 0.633225C6.90283 0.391038 6.18455 0.426194 5.56722 0.738694L3.78512 1.63323C3.35415 1.85198 3.32309 2.45744 3.72688 2.71916L9.43038 6.41057L5.60605 8.37541L3.34639 7.36369C3.0086 7.21135 2.61646 7.21916 2.28645 7.38713L1.03626 8.01604C0.675176 8.19963 0.578112 8.67229 0.842127 8.98088L3.68029 12.3129C3.91713 12.5903 4.26268 12.7504 4.62376 12.7504H9.97006C10.1642 12.7504 10.3544 12.7035 10.5253 12.6176L21.1208 7.28947C22.9262 6.37932 24.3239 4.81682 25.0345 2.91447C25.4033 1.9301 24.6773 0.875413 23.629 0.875413H21.4004C20.6161 0.875413 19.8396 1.06291 19.1407 1.42229L15.1184 3.48869ZM0.325745 17.7504C0.325745 18.4418 0.880953 19.0004 1.56817 19.0004H23.9318C24.619 19.0004 25.1742 18.4418 25.1742 17.7504C25.1742 17.059 24.619 16.5004 23.9318 16.5004H1.56817C0.880953 16.5004 0.325745 17.059 0.325745 17.7504Z" fill="white"/>
          </svg>
          <WFTranslate k="departures">Departures</WFTranslate>
        </div>
        <div class="flight-direction-menu-item" @click="setFlightDirection('arrivals')" :class="{ active: flightDirection == 'arrivals'}">
          <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.761719 6.51953L0.75 2.65625C0.75 2.25391 1.12109 1.95703 1.51172 2.04297L2.90234 2.35156C3.31641 2.44141 3.65234 2.73828 3.80078 3.13281L4.5 5L9.47266 6.46875L7.85156 0.796875C7.73828 0.398438 8.03906 0 8.45312 0H10.0195C10.4727 0 10.8867 0.242188 11.1094 0.636719L15.3672 8.20703L19.5547 9.44531C20.1758 9.62891 20.7578 9.93359 21.2617 10.3359L22.6055 11.4141C23.543 12.1641 23.3125 13.6523 22.1875 14.0781C20.5781 14.6875 18.8203 14.7852 17.1562 14.3516L5.50391 11.3203C5.07031 11.207 4.67578 10.9805 4.35938 10.6602L1.12109 7.39844C0.890625 7.16406 0.757812 6.84766 0.757812 6.51953H0.761719ZM2 17.5H24.5C25.1914 17.5 25.75 18.0586 25.75 18.75C25.75 19.4414 25.1914 20 24.5 20H2C1.30859 20 0.75 19.4414 0.75 18.75C0.75 18.0586 1.30859 17.5 2 17.5Z" fill="white"/>
          </svg>
          <WFTranslate k="arrivals">Arrivals</WFTranslate>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import {mapState} from "vuex";

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('wf', ['language']),
    flightDirection() {
      return this.$store.state.flightDirection;
    }
  },
  methods: {
    setFlightDirection (direction) {
      this.$store.dispatch('setFlightDirection', direction);
      this.$store.dispatch('setPOI', null);
    },
  },
}
</script>

<style lang="postcss">
  .flight-direction-menu-item {
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    font-size: 1.8rem;
    border: 1px solid #0F417C;

    label {
      display: inline-block;
    }

    svg {
      display: inline-block;
      height: 2.5rem;
      margin-right: 1rem;

      path {
        fill: #0F417C !important;
      }
    }

    &:first-child {
       border-top-left-radius: 3.2rem;
       border-bottom-left-radius: 3.2rem;
     }
    &:last-child {
       border-top-right-radius: 3.2rem;
       border-bottom-right-radius: 3.2rem;
     }
    &.active {
     background: #0F417C;
     color: #fff;

      svg {
        path {
          fill: #fff !important;
        }
      }
    }
  }
</style>
